module.exports = __webpack_public_path__ + "static/media/IMG_2605.18200fc4.JPG";